import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './PinnedBadges.css';

// Using the same centralized config as BadgeShowcase
const badgeConfig = {
    'the_spark': { name: 'The Spark', icon: LucideIcons.Sparkle, color: 'text-gray-400' },
    'proto_star': { name: 'Proto-Star', icon: LucideIcons.CircleDot, color: 'text-sky-400' },
    'ascendant_star': { name: 'Ascendant Star', icon: LucideIcons.Orbit, color: 'text-indigo-400' },
    'radiant_star': { name: 'Radiant Star', icon: LucideIcons.Network, color: 'text-purple-400' },
    'giant_star': { name: 'Giant Star', icon: LucideIcons.Sun, color: 'text-amber-400' },
    'elder_star': { name: 'Elder Star', icon: LucideIcons.Crown, color: 'text-yellow-300' },
    'respected_voice': { name: 'Respected Voice', icon: LucideIcons.Star, color: 'text-yellow-400' },
    'community_pillar': { name: 'Community Pillar', icon: LucideIcons.ShieldCheck, color: 'text-sky-400' },
    'echo_weaver': { name: 'Echo Weaver', icon: LucideIcons.Gem, color: 'text-purple-400' },
    'echo_magnate': { name: 'Echo Magnate', icon: LucideIcons.Crown, color: 'text-amber-300' },
    'echo_champion': { name: 'Echo Champion', icon: LucideIcons.Trophy, color: 'text-yellow-400' },
    'echo_legend': { name: 'Echo Legend', icon: LucideIcons.Hexagon, color: 'text-red-400' },
    'echo_deity': { name: 'Echo Deity', icon: LucideIcons.Sun, color: 'text-orange-500' },
    'lottery_first_entry': { name: "Fortune's Favorite", icon: LucideIcons.Ticket, color: 'text-green-400' },
    'lottery_high_roller': { name: 'High Roller', icon: LucideIcons.Gem, color: 'text-purple-400' },
    'lottery_consistent_contender': { name: 'Consistent Contender', icon: LucideIcons.Calendar, color: 'text-blue-400' },
};


const PinnedBadges = ({ pinnedBadgeIds = [] }) => {
    const { t } = useTranslation();
    if (pinnedBadgeIds.length === 0) {
        return null; // Don't render anything if there are no pinned badges
    }

    return (
        <div className="pinned-badges-container">
            <h3 className="pinned-badges-title">
                <LucideIcons.Star size={16} className="icon" />
                <span>{t('pinnedBadges.showcase')}</span>
            </h3>
            <div className="pinned-badges-grid">
                {pinnedBadgeIds.map(badgeId => {
                    const badge = badgeConfig[badgeId];
                    if (!badge) return null;
                    const Icon = badge.icon;
                    return (
                        <div key={badgeId} className="pinned-badge-item" title={badge.name}>
                            <Icon size={32} className={badge.color} />
                        </div>
                    );
                })}
                {/* Fill remaining slots to maintain grid structure */}
                {Array.from({ length: 5 - pinnedBadgeIds.length }).map((_, index) => (
                    <div key={`placeholder-${index}`} className="pinned-badge-placeholder">
                        <LucideIcons.Plus size={20} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PinnedBadges;
